/**
 * Programming languages the coding drill can actually grade in the browser.
 * Preference follows resume/JD skills — Java is not matched inside JavaScript.
 */

export const CODING_LANGUAGES = [
  { id: 'javascript', label: 'JavaScript' },
  { id: 'typescript', label: 'TypeScript' },
  { id: 'python', label: 'Python' },
  { id: 'java', label: 'Java' },
  { id: 'kotlin', label: 'Kotlin' },
  { id: 'csharp', label: 'C#' },
  { id: 'go', label: 'Go' },
  { id: 'cpp', label: 'C++' },
  { id: 'php', label: 'PHP' },
  { id: 'ruby', label: 'Ruby' },
];

const RULES = [
  { id: 'typescript', test: /\btypescript\b|\bts\b/ },
  { id: 'python', test: /\bpython\b|\bdjango\b|\bflask\b|\bfastapi\b/ },
  { id: 'csharp', test: /\bc#\b|\bcsharp\b|\bdotnet\b|\b\.net\b/ },
  { id: 'cpp', test: /\bc\+\+\b|\bcpp\b/ },
  { id: 'go', test: /\bgolang\b|\bgo\b/ },
  { id: 'kotlin', test: /\bkotlin\b/ },
  { id: 'php', test: /\bphp\b|\blaravel\b/ },
  { id: 'ruby', test: /\bruby\b|\brails\b/ },
  { id: 'java', test: /\bjava\b/ },
  { id: 'javascript', test: /\bjavascript\b|\bnode\.?js\b|\breact\b/ },
];

export const normalizeCodingLanguage = (raw) => {
  const text = String(raw || '').toLowerCase().replace(/c\+\+/, 'cpp');
  if (!text) return 'javascript';
  const exact = CODING_LANGUAGES.find((row) => row.id === text);
  if (exact) return exact.id;
  const hit = RULES.find((row) => row.test.test(text));
  return hit ? hit.id : 'javascript';
};

export const preferredCodingLanguage = (skills = [], extra = '') => {
  const text = [
    ...(skills || []).map((row) => (typeof row === 'string' ? row : row?.name || '')),
    extra,
  ]
    .join(' ')
    .toLowerCase();
  const hit = RULES.find((row) => row.test.test(text));
  return hit ? hit.id : 'javascript';
};

export const codingLanguageLabel = (id) =>
  CODING_LANGUAGES.find((row) => row.id === id)?.label || id;
